import script from "./Customer.vue?vue&type=script&setup=true&lang=js"
export * from "./Customer.vue?vue&type=script&setup=true&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=aa31e308&scoped=true&lang=css"
import "./Customer.vue?vue&type=style&index=1&id=aa31e308&scoped=true&lang=css"
import "./Customer.vue?vue&type=style&index=2&id=aa31e308&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa31e308"]])

export default __exports__